import React from 'react';
import PropTypes from 'prop-types';
import TreeRow from './TreeRow';
import { IconSiteList } from 'svgIcons/MotionPortalIcons';
import { map } from 'lodash';
import LocationNode from './LocationNode';
import UnassignedNode from './UnassignedNode';
import { conditionIndicesViewOptions } from '../constants';
import AssetNode from './AssetNode';
import { useNodeExpansion } from './HierarchyExpansionContext';

const SiteNode = ({
    site,
    depth,
    selectedAsset,
    onSelectAsset,
    leftPanelSize,
    allAssets,
    conditionIndicesView,
    selectionNodeIds,
    selectedAssetSignalCounts
}) => {
    const { expanded, toggle } = useNodeExpansion(`site-${site?.siteId}`);
    const hasSelectionDot = !!selectionNodeIds?.has(`site-${site?.siteId}`);

    return (
        <>
            <TreeRow
                depth={depth}
                icon={<IconSiteList />}
                label={site.siteName}
                hasChildren={!!(site?.notConfiguredAssets?.length || site?.notConfiguredPowertrains?.length || site?.locations?.length)}
                isExpanded={expanded}
                condition={site?.condition}
                onToggle={toggle}
                hasSelectionDot={hasSelectionDot}
            />
            {expanded &&
                <>
                    {conditionIndicesView === conditionIndicesViewOptions.HIERARCHY ?
                        site?.notConfiguredAssets?.length > 0 &&
                        <UnassignedNode
                            unAssignedNode={site?.notConfiguredAssets}
                            depth={depth + 1}
                            selectedAsset={selectedAsset}
                            onSelectAsset={onSelectAsset}
                            condition={site?.overallNotConfiguredAssetsCondition}
                            isForSingleAsset={true}
                            leftPanelSize={leftPanelSize}
                            allAssets={allAssets}
                            nodeId={`singleAssets-site-${site?.siteId}`}
                            selectionNodeIds={selectionNodeIds}
                            selectedAssetSignalCounts={selectedAssetSignalCounts}
                        /> :
                        map(site?.notConfiguredAssets, (asset, index) =>
                            <AssetNode
                                key={asset?.assetId}
                                depth={depth}
                                index={index}
                                selectedAsset={selectedAsset}
                                asset={asset}
                                allAssets={allAssets}
                                onSelectAsset={onSelectAsset}
                                leftPanelSize={leftPanelSize}
                                selectionNodeIds={selectionNodeIds}
                                selectedAssetSignalCounts={selectedAssetSignalCounts}
                            />)
                    }
                    {site?.notConfiguredPowertrains?.length > 0 &&
                        <UnassignedNode
                            unAssignedNode={site?.notConfiguredPowertrains}
                            depth={depth + 1}
                            selectedAsset={selectedAsset}
                            onSelectAsset={onSelectAsset}
                            condition={site?.overallNotConfiguredPowertrainsCondition}
                            leftPanelSize={leftPanelSize}
                            allAssets={allAssets}
                            nodeId={`unassignedPowertrains-site-${site?.siteId}`}
                            selectionNodeIds={selectionNodeIds}
                            selectedAssetSignalCounts={selectedAssetSignalCounts}
                        />
                    }
                    {map(site?.locations, location =>
                        <LocationNode
                            key={location?.locationId}
                            location={location}
                            depth={depth + 1}
                            selectedAsset={selectedAsset}
                            onSelectAsset={onSelectAsset}
                            leftPanelSize={leftPanelSize}
                            allAssets={allAssets}
                            selectionNodeIds={selectionNodeIds}
                            selectedAssetSignalCounts={selectedAssetSignalCounts}
                        />
                    )}
                </>
            }
        </>
    );
};

SiteNode.propTypes = {
    site: PropTypes.object.isRequired,
    depth: PropTypes.number.isRequired,
    selectedAsset: PropTypes.object,
    onSelectAsset: PropTypes.func,
    leftPanelSize: PropTypes.number,
    showThreshold: PropTypes.bool,
    showTrend: PropTypes.bool,
    allAssets: PropTypes.array,
    conditionIndicesView: PropTypes.string,
    selectionNodeIds: PropTypes.instanceOf(Set),
    selectedAssetSignalCounts: PropTypes.object
};

export default SiteNode;
